import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Arrow = ({
    markerEnd="url(#arrowhead)",
    points,
    onMouseOver,
    onMouseDown,
    className="",
    onMouseLeave,
    fill,
    opacity,
    stroke,
    strokeWidth,
    segmentation,
}) => { 
    const fl = (x) => Math.floor(x);
    let d = "M " + fl(points[0]) + ' ' + fl(points[1]);
    let pts = "";
    for (let i=2 ; i < points.length - 1; i+=2) {
        pts += (fl(points[i]) + ' ' + fl(points[i+1])) + ' ';
    }
    let command = segmentation ? "Q" : "C";
    let u = d + " " + command + " " + pts;
    return (
        <path
          className={className}
          onMouseDown={onMouseDown}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          d={u}
          strokeWidth={strokeWidth}
          opacity={opacity}
          markerEnd={markerEnd}
          >
        </path>);
}
export default Arrow;
